import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/adherentpret`;
const token = localStorage.getItem("token");

///GET
// Fonction pour récupérer tous les prêts
export const getAllAdherentPrets = async () => {
  try {
    const response = await axios.get(`${apiUrl}/all`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la récupération des prêts :", error);
    throw error;
  }
}

/// POST
// Fonction pour créer un nouveau prêt
export const createAdherentPret = async (adherentPretData) => {
  try {
    const response = await axios.post(`${apiUrl}/create`, adherentPretData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la création du prêt :", error);
    throw error;
  }
};

/// PUT
// Fonction pour mettre à jour un prêt existant
export const updateAdherentPret = async (id, adherentPretData) => {
  try {
    const response = await axios.put(`${apiUrl}/update/${id}`, adherentPretData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la mise à jour du prêt :", error);
    throw error;
  }
};

/// DELETE
// Fonction pour supprimer un prêt
export const deleteAdherentPret = async (id) => {
  try {
    const response = await axios.delete(`${apiUrl}/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors de la suppression du prêt :", error);
    throw error;
  }
}

